export default __webpack_public_path__ + "static/media/full3.642756a1.jpg";